import { doGetCall } from "../config/rest";
export const FETCH_CONTACTUSDATA_BEGIN = "FETCH_CONTACTUSDATA_BEGIN";
export const FETCH_CONTACTUSDATA_SUCCESS = "FETCH_CONTACTUSDATA_SUCCESS";
export const FETCH_CONTACTUSDATA_FAILURE = "FETCH_CONTACTUSDATA_FAILURE";

export const fetchContactUsDataBegin = () => ({
  type: FETCH_CONTACTUSDATA_BEGIN
});

export const fetchContactUsDataSuccess = (contactUsResponse, contactUsPageComponents) => ({
  type: FETCH_CONTACTUSDATA_SUCCESS,
  totalResponse: { contactUsResponse },
  payload: { contactUsPageComponents }
});

export const fetchContactUsDataFailure = error => ({
  type: FETCH_CONTACTUSDATA_FAILURE,
  payload: { error }
});

function getContactUsPageComponents() {
  if(global.preview){
    return doGetCall(`/wp-json/previews/v1/preview?page_id=${global.id}`);
  }
  else{
    return doGetCall(`/wp-json/wp/v2/pages?slug=${global.slug}`);
  }
}
  
export function fetchContactUsPageComponents() {
  return dispatch => {
    return getContactUsPageComponents()
      .then(json => {
        dispatch(fetchContactUsDataSuccess(json[0], json[0].acf));
        return json;
      })
      .catch(error =>
        dispatch(fetchContactUsDataFailure(error))
      );
  };
}
  